module.exports = __webpack_public_path__ + "img/pro-plan-icon.9a362ec8.svg";